export const STORAGE ={
    droit_acces_date_arrivee : 'droitAccesDateArrivee',
    droit_acces_date_depart : 'droitAccesDateDepart',
    message_accueil_deja_affiche  : 'messageAccueilDejaAffiche',
    info_profile_client : 'infoProfileClient'
}

export const ENCRYPTION_KEY = '3F43X42kWzdxKr'
